import React from 'react';
import PropTypes, { symbol } from 'prop-types';
import styled from 'styled-components';
import RCore from 'RCore';
import UI from 'UI';
import _ from 'lodash';

//These lines are needed to get common i18
const i18Common = require('../../../../i18/i18.Common');
const i18 = RCore.getTranslation.bind({ dict: i18Common });

const Container = styled.div``;

const Item = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: flex-start;
    align-items: center;
    align-content: center;
    margin: 20px 0px;

    .list-player-name {
        font-size: 1.25rem;
        font-weight: normal;
        padding-right: 15px;
        flex: 0 1 21%;
        min-width: 180px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;

        > span {
            text-transform: uppercase;
            font-size: 0.825rem;
            display: block;
            letter-spacing: 0.2px;
            margin-top: 5px;
            font-weight: 300;
        }
    }

    .chart-wrap {
        width: 100%;
    }

    .list-team-name {
        text-transform: uppercase;
        font-size: 0.875rem;
    }
`;

const BarChart = styled.div`
    height: 28px;
    width: ${props => props.width}%;
    background-color: ${props => props.theme.color};
    position: relative;

    &:after {
        content: '';
        width: 2px;
        height: calc(100% + 14px);
        background-color: inherit;
        display: inline-block;
        position: absolute;
        top: -7px;
        left: 0;
    }

    .ptl_highlight & {
        background-color: ${props => props.theme.content.accentColor};
    }
`;

const ScoreBlock = styled.div`
    z-index: 2;
    font-size: 32px;
    font-weight: bold;
    white-space: nowrap;
    margin-left: 10px;
    .tl-unit {
        font-size: 12px;
        margin-left: 3px;
    }

    .ptl_highlight & {
        color: ${props => props.theme.content.accentColor};

        .units & {
            color: ${props => props.theme.content.accentColor};
        }
    }
    text-align: right;
`;
const Fake = styled.div`
    visibility: hidden;
    font-size: 32px;
    background: red;
    white-space: nowrap;
    padding: 0 15px;
`;

const Header = ({ valueTitle }, ctx) => {
    let lang = _.get(ctx, 'info.lang', 'en');

    return <h1 />;
};

const Row = ({ player, max, rank, highlightFirstPlayer, highlightTeam, maxDislayValue }, ctx) => {
    let name = RCore.playerShortName(player.name);
    let chartWidth = 100 / (max / player.value);
    let lang = _.get(ctx, 'info.lang', 'en');
    let symbols = Math.max((Math.round(max) + '').length, (maxDislayValue + '').length);

    return (
        <Item
            key={player.id}
            className={highlightFirstPlayer || highlightTeam === player.teamId ? 'ptl_highlight' : ''}
        >
            <div className={`list-player-name __c__c1style${rank}`}>
                {name}
                {player.position &&
                    player.teamShortName && (
                        <span>
                            {i18(player.position, lang)}, {player.teamShortName}
                        </span>
                    )}
            </div>
            <div className="chart-wrap">
                <BarChart width={chartWidth} className={`__c__b1_style${rank}`} />
            </div>
            <ScoreBlock style={{ minWidth: symbols * 22 + 5 }} className={`__c__c2style${rank}`}>
                {player.displayValue || player.value}
                <span className="tl-unit">{player.unit}</span>
            </ScoreBlock>
        </Item>
    );
};

Header.contextTypes = {
    info: PropTypes.object
};

Row.contextTypes = {
    info: PropTypes.object
};

export default { Header, Row, Container };



/** WEBPACK FOOTER **
 ** ../src/widgets/components/sm/views/lists/PlayersListWithChart.js
 **/